// src/pages/GalleriesPhotos/AddPhotoToAlbumModal.jsx
import React, { useState } from "react";
import { FaSave, FaTimes, FaUpload } from "react-icons/fa";
import Button from "./../../components/Button/Button";
import {
  addPhoto,
  updatePhoto,
  updatePhotoImage,
  deletePhoto,
} from "./../../services/photoServices";
import { toast } from "react-toastify";

const AddPhotoToAlbumModal = ({ isOpen, onClose, galleryId, photoId }) => {
  const [photoUrl, setPhotoUrl] = useState("");
  const [description, setDescription] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  if (!isOpen) return null;

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleUploadSubmit = async (e) => {
    e.preventDefault();
    try {
      if (photoId && selectedFile) {
        const updatedPhoto = await updatePhotoImage(photoId, selectedFile);
        setPhotoUrl(updatedPhoto.photo_url);
        toast.success("Image mise à jour avec succès.");
        setIsUploadModalOpen(false);
      }
    } catch (error) {
      console.error("Erreur lors de la mise à jour de l'image:", error);
      toast.error("Erreur lors de la mise à jour de l'image.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const photoData = {
        gallerie_id: galleryId,
        description,
        is_active: isActive,
      };

      if (photoId) {
        await updatePhoto(photoId, photoData);
        toast.success("Photo mise à jour avec succès.");
      } else {
        const newPhoto = await addPhoto(photoData);
        setPhotoUrl(newPhoto.photo_url);
        toast.success("Photo ajoutée avec succès.");
      }

      onClose();
    } catch (error) {
      console.error("Erreur lors de la sauvegarde de la photo:", error);
      toast.error("Erreur lors de la sauvegarde de la photo.");
    }
  };

  const handleCancel = async () => {
    try {
      if (photoId) {
        await deletePhoto(photoId);
        toast.success("Photo supprimée avec succès.");
      }
      onClose();
    } catch (error) {
      console.error("Erreur lors de la suppression de la photo:", error);
      toast.error("Erreur lors de la suppression de la photo.");
    }
  };

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50">
      <div className="modal-box bg-white dark:bg-slate-900 dark:text-white p-5 rounded-2xl shadow-2xl max-w-lg w-full">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-lg font-bold uppercase tracking-[0.18em]">
            Ajouter une Photo
          </h3>
          <button
            type="button"
            onClick={handleCancel}
            className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-black/10 dark:bg-black/30 hover:bg-black/30 dark:hover:bg-black/60"
          >
            <FaTimes />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <Button
            icon={FaUpload}
            text="Uploader une image"
            onClick={(e) => {
              e.preventDefault();
              setIsUploadModalOpen(true);
            }}
            className="gap-2 mb-4"
          />

          <input
            type="text"
            value={photoUrl}
            placeholder="URL de la photo (rempli après upload)"
            className="input input-bordered w-full mb-4 dark:text-white dark:bg-slate-800 dark:border-slate-700 text-xs"
            readOnly
          />

          {photoUrl && (
            <div className="mb-4">
              <p className="text-[11px] text-slate-500 dark:text-slate-300 mb-1">
                Aperçu :
              </p>
              <img
                src={photoUrl}
                alt="Aperçu"
                className="w-full max-h-56 object-contain rounded-lg border border-slate-200 dark:border-slate-700"
              />
            </div>
          )}

          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Description de la photo"
            className="textarea textarea-bordered w-full mb-4 dark:text-white dark:bg-slate-800 dark:border-slate-700"
            required
          />

          <label className="flex justify-start items-center space-x-2 mb-4 text-sm">
            <input
              type="checkbox"
              checked={isActive}
              onChange={(e) => setIsActive(e.target.checked)}
              className="checkbox checkbox-primary"
            />
            <span>Photo active (visible dans l'album)</span>
          </label>

          <div className="flex justify-center gap-4">
            <Button
              text="Enregistrer"
              icon={FaSave}
              type="submit"
              className="gap-2"
            />
            <Button
              text="Annuler"
              icon={FaTimes}
              onClick={handleCancel}
              className="gap-2 btn-ghost"
            />
          </div>
        </form>
      </div>

      {/* Sous-modale upload fichier */}
      {isUploadModalOpen && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div className="bg-white dark:bg-slate-900 p-6 rounded-2xl shadow-2xl max-w-md w-full">
            <h2 className="text-lg font-bold uppercase p-2 mb-4 text-center bg-primary text-white rounded-md tracking-[0.18em]">
              Uploader une Image
            </h2>
            <form
              onSubmit={handleUploadSubmit}
              className="flex flex-col items-center space-y-4 w-full"
            >
              <input
                type="file"
                onChange={handleFileChange}
                accept="image/*"
                className="w-full text-sm"
              />
              <div className="flex gap-4 justify-center">
                <Button
                  text="Sauvegarder"
                  type="submit"
                  icon={FaSave}
                  className="gap-2"
                />
                <Button
                  text="Fermer"
                  onClick={() => setIsUploadModalOpen(false)}
                  icon={FaTimes}
                  className="gap-2 btn-ghost"
                  type="button"
                />
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddPhotoToAlbumModal;
